export default __webpack_public_path__ + "940ebcadefcc9970f0e94d441014012a.vcf";